"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 1,
    class: "occupied-colony-space"
};
const _hoisted_2 = {
    key: 2,
    class: "colony-track-marker"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_build_benefit = (0, vue_1.resolveComponent)("build-benefit");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [
        (_ctx.idx <= 2)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_build_benefit, {
                key: 0,
                metadata: _ctx.metadata,
                idx: _ctx.idx
            }, null, 8, ["metadata", "idx"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.player !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
                (0, vue_1.createElementVNode)("div", {
                    class: (0, vue_1.normalizeClass)(`board-cube colony-cube board-cube--${_ctx.player}`)
                }, null, 2)
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.marker)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
